/** Product copy shared by native and web music-access renderers. */
export const MUSIC_ACCESS_FLOW_COPY = {
  exclusiveSong: "Exclusive Song",
  exclusiveDjSet: "Exclusive DJ Set",
  unlock: "Unlock",
  // "Free" is dropped from the button — the price row above already says it.
  unlockFree: "Unlock",
  unlocked: "Unlocked",
  membersOnly: "Members only",
  /** Members-only music, to a fan outside its club. */
  membersOnlyLine: (clubArtistName: string) =>
    `For members of ${clubArtistName}’s fan club. Members play it in full.`,
  /** The app's way into members-only music's club: its artist's Live Link. */
  joinFanClub: "Join the fan club",
  preview: "Preview",
  play: "Play",
  checkoutHeading: "Checkout",
  loginToUnlock: "Log in to unlock",
  explainerTitle: "What are Exclusive Songs?",
  explainerBody:
    "Exclusive Songs let you experience special tracks from your favorite artists, not generally available on most streaming platforms. Each track is personally chosen by the artist to give fans a closer look into their creative world.",
} as const;

/** Shared visual recipe used to keep the native and DOM renderers aligned. */
export const MUSIC_ACCESS_FLOW_VISUAL_RECIPE = {
  colors: {
    white: "#FFFFFF",
    black: "#000000",
    lightGrey: "rgba(255, 255, 255, 0.62)",
    white10: "rgba(255, 255, 255, 0.10)",
    white20: "rgba(255, 255, 255, 0.20)",
    white50: "rgba(255, 255, 255, 0.50)",
    white70: "rgba(255, 255, 255, 0.70)",
    white80: "rgba(255, 255, 255, 0.80)",
    border: "rgba(255, 255, 255, 0.20)",
    gem: "#C084FC",
    gemText: "#E9D5FF",
    gemBackground: "rgba(126, 87, 194, 0.18)",
    gemBorder: "rgba(168, 85, 247, 0.55)",
    directPaymentBackground: "rgba(16, 185, 129, 0.12)",
    directPaymentBorder: "rgba(16, 185, 129, 0.35)",
    directPaymentText: "#A7F3D0",
    directPaymentIcon: "#86EFAC",
  },
  // Vertical navy-to-sky gradient behind the details sheet (LIS-985).
  // `backgroundStops` is the structured source both renderers share: the web
  // `background` string below is its CSS form, and the mobile Background SVG
  // reads the stops directly — change them together.
  backgroundStops: [
    { offset: 0, color: "#0B2268" },
    { offset: 0.2, color: "#092B7D" },
    { offset: 0.4, color: "#0A3485" },
    { offset: 0.65, color: "#124E9A" },
    { offset: 0.85, color: "#2175B4" },
    { offset: 1, color: "#2A9BC0" },
  ],
  background:
    "linear-gradient(180deg, #0B2268 0%, #092B7D 20%, #0A3485 40%, #124E9A 65%, #2175B4 85%, #2A9BC0 100%)",
  geometry: {
    maxWidth: 520,
    sheetRadius: 24,
    artworkRadius: 8,
    cardRadius: 12,
    controlRadius: 8,
    pagePadding: 16,
    gap: 12,
    actionHeight: 56,
    actionIconSize: 22,
    previewDurationSeconds: 10,
  },
} as const;
